import { User } from '@gbr-monorepo/interfaces';
import { TableColumn } from './interfaces';

export const columns: TableColumn<User>[] = [
    {
        name: 'GID',
        selector: 'gid',
        row: (row: User) => row.gid,
        width: '3'
    },
    {
        name: 'Name',
        selector: 'name',
        row: (row: User) => `${row.firstName} ${row.lastName}`,
        width: '5'
    },
    {
        name: 'E-Mail',
        selector: 'email',
        row: (row: User) => row.email,
        width: '7'
    },
    {
        name: 'Roles',
        selector: 'roles',
        row: (row: User) => row.roles.join(', '),
        width: '5'
    }
];
